import { render } from "./InputDate.vue?vue&type=template&id=34612036&scoped=true"
import script from "./InputDate.vue?vue&type=script&lang=js"
export * from "./InputDate.vue?vue&type=script&lang=js"

import "./InputDate.vue?vue&type=style&index=0&id=34612036&scoped=true&lang=css"

import exportComponent from "D:\\wamp\\www\\Proyectos\\LICEO\\portalalumnos\\portalalumnos\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-34612036"]])

export default __exports__